export enum ImagingUltrasoundConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'imagingUltrasound/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'imagingUltrasound/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_DATE_TIME = 'imagingUltrasound/SET_DATE_TIME',
  SET_ASSESSED_BY = 'imagingUltrasound/SET_ASSESSED_BY',
  SET_PTA = 'imagingUltrasound/SET_PTA',
  SET_PROCEDURE_COMPLICATIONS = 'imagingUltrasound/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'imagingUltrasound/SET_AUTHORIZATION',
  SET_COMMENTS = 'imagingUltrasound/SET_COMMENTS',
  SET_TYPE = 'imagingUltrasound/SET_TYPE',
  SAVE_IMAGING_ULTRASOUND = 'imagingUltrasound/SAVE_IMAGING_ULTRASOUND',
  SET_ADD_TO_TIMELINE = 'imagingUltrasound/SET_ADD_TO_TIMELINE',
  RESET_STATE = 'imagingUltrasound/RESET_STATE',
  SET_UPDATE_INPUT_ROWS = 'imagingUltrasound/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'imagingUltrasound/SET_DATE',
  SET_TIME = 'imagingUltrasound/SET_TIME',
  SET_RESPONSE = 'imagingUltrasound/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'imagingUltrasound/SET_RESPONSE_PNNV',
  SET_STATE = 'imagingUltrasound/SET_STATE',
  SET_SAVE_RESPONSE = 'imagingUltrasound/SET_SAVE_RESPONSE',
  SET_ROLE_PERFORMING = 'imagingUltrasound/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'imagingUltrasound/SET_ROLE_PERFORMING_PNNV',
  SET_LOCATION = 'imagingUltrasound/SET_LOCATION',
  SET_FINDINGS = 'imagingUltrasound/SET_FINDINGS',
}
